import { Component, Input } from '@angular/core';
import { ChartType, ChartOptions } from 'chart.js';
import { InformeOperativo } from '../../../models/booking-reports.model';

@Component({
    selector: 'app-operational-report',
    templateUrl: './operational-report.component.html',
    styleUrls: ['./operational-report.component.scss'],
    standalone: false
})
export class OperationalReportComponent {
  @Input() data: InformeOperativo | null = null;

  get hasRecords(): boolean {
    return this.data != null && this.data.filas.length > 0;
  }

  getTotalAppointments(): number {
    if (!this.data) return 0;
    const kpis = this.data.kpis;
    return kpis.citasCompletadas + kpis.citasCanceladas + kpis.citasNoPresentadas;
  }

  getCompletedPercentage(): number {
    const total = this.getTotalAppointments();
    if (total === 0) return 0;
    return (((this.data && this.data.kpis.citasCompletadas) || 0) / total) * 100;
  }

  getCancelledPercentage(): number {
    const total = this.getTotalAppointments();
    if (total === 0) return 0;
    return (((this.data && this.data.kpis.citasCanceladas) || 0) / total) * 100;
  }

  getNoShowPercentage(): number {
    const total = this.getTotalAppointments();
    if (total === 0) return 0;
    return (((this.data && this.data.kpis.citasNoPresentadas) || 0) / total) * 100;
  }

  get statusChartData(): number[] {
    return this.data
      ? [
          this.data.kpis.citasCompletadas,
          this.data.kpis.citasCanceladas,
          this.data.kpis.citasNoPresentadas
        ]
      : [];
  }

  statusChartLabels: string[] = ['Completadas', 'Canceladas', 'No Presentadas'];

  statusChartType: ChartType = 'doughnut';

  statusChartColors = [{ backgroundColor: ['#28a745', '#dc3545', '#fd7e14'] }];

  statusChartOptions: ChartOptions<'doughnut'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right'
      }
    }
  };

  trackByEmployee(index: number, row: any): string {
    return row.empleadoId;
  }
}